import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=161f7870&scoped=true&"
import script from "./Guest.vue?vue&type=script&lang=js&"
export * from "./Guest.vue?vue&type=script&lang=js&"
import style0 from "./Guest.vue?vue&type=style&index=0&id=161f7870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f7870",
  null
  
)

export default component.exports